import { render, staticRenderFns } from "./EmbedContent.vue?vue&type=template&id=d6070648&"
import script from "./EmbedContent.vue?vue&type=script&lang=js&"
export * from "./EmbedContent.vue?vue&type=script&lang=js&"
import style0 from "./EmbedContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports